
import { Course } from '../types';

export const harassment_boundaries: Course = {
  id: "harassment_boundaries",
  title: "Persistence vs Harassment",
  description: "The fine line between being a persistent father and being a harasser.",
  icon: "🛡️",
  totalModules: 11,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/harassment_boundaries/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "In family court, what is the primary factor judges consider regarding your actions?",
        "o": [
            "Your good intentions behind the actions.",
            "The explanations you provide for your behaviour.",
            "The emotional or practical effect your behaviour had on the recipient.",
            "How difficult the situation was for you personally."
        ],
        "a": 2
    },
    {
        "q": "According to the '2-Contact Rule' and the Protection from Harassment Act 1997, how can a polite apology contribute to a legal 'Course of Conduct'?",
        "o": [
            "It can never contribute, as apologies are always seen positively.",
            "It becomes the second unwanted incident if the first was an unwanted text and the other parent had said stop.",
            "It only counts if the apology is long and contains personal feelings.",
            "Only aggressive texts, not polite apologies, can establish harassment."
        ],
        "a": 1
    },
    {
        "q": "What is 'The Golden Rule' for digital communication in high-conflict situations?",
        "o": [
            "Send multiple detailed messages to ensure all points are covered.",
            "Only respond to every message you receive, no matter the length.",
            "Send one short, factual message and then stop, avoiding chasing a response.",
            "Use social media to vent frustrations and seek advice from your network."
        ],
        "a": 2
    },
    {
        "q": "What is the legal implication of attempting to bypass a no-contact request or block by using a third party?",
        "o": [
            "It is considered a reasonable effort to maintain communication.",
            "It demonstrates a desire to resolve conflict.",
            "It is a form of indirect harassment and is illegal.",
            "It is only acceptable if the third party is a family member."
        ],
        "a": 2
    },
    {
        "q": "To protect yourself from allegations and starve high-conflict individuals of drama, which two communication strategies should you employ?",
        "o": [
            "Aggressive and Emotional.",
            "Passive-Aggressive and Defensive.",
            "Brief, Informative, Friendly, Firm (BIFF) and Gray Rock Method.",
            "Overly Detailed and Justificatory."
        ],
        "a": 2
    }
]
};
